import { InlineLoading } from "carbon-components-react"
import React from "react"
import "./PlayerSkeleton.scss"

const PlayerSkeleton = (props) => {

    const { loadingText } = props
    return (
        <div className="player-skeleton aspect-ratio">
            <div className="player-skeleton__content">
                <InlineLoading description={loadingText || "Loading..."} status='active' />
            </div>
        </div>
    )
}

export default PlayerSkeleton